import { render, staticRenderFns } from "./Exhibitionmeeting.vue?vue&type=template&id=b8664ad6&"
import script from "./Exhibitionmeeting.vue?vue&type=script&lang=js&"
export * from "./Exhibitionmeeting.vue?vue&type=script&lang=js&"
import style0 from "./Exhibitionmeeting.vue?vue&type=style&index=0&id=b8664ad6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports